import { path } from "../paths";

const ROOTS_RECEIVABLES = "/receivables";

export const PATH_RECEIVABLES = {
  root: ROOTS_RECEIVABLES,
  general: {
    unclassified: path(ROOTS_RECEIVABLES, "/unclassified"),
    saleInvoice: {
      root: path(ROOTS_RECEIVABLES, "/sale-invoice"),
      general: {
        saleInvoiceDraft: path(`${ROOTS_RECEIVABLES}/sale-invoice`, "/drafts"),
      },
    },
    saleOrder: {
      root: path(ROOTS_RECEIVABLES, "/sale-order"),
    },
    saleDeliveryNote: {
      root: path(ROOTS_RECEIVABLES, "/sale-delivery-note"),
      general: {
        saleDeliveryNoteDraft: path(
          `${ROOTS_RECEIVABLES}/sale-delivery-note`,
          "/drafts",
        ),
      },
    },
  },
};
